import React from "react";

import { BasicButton, ButtonType, Icon, IconSize } from "@gaming/xds-react-js";
import { Launch } from "@gaming/xds-react-js-icons";

import {
  CreateTitleAndConfigureGameUrl,
  DevelopmentDocumentationUrl,
  GdkAccessResourcesUrl,
} from "../../constants";
import { useStrings } from "../../localization/localizationHelpers";
import * as styles from "./DevelopmentResources.module.css";

export const DevelopmentResources = () => {
  const [
    title,
    description,
    gdkResourcesTitle,
    gdkResourcesDescription,
    firstTitle,
    firstTitleDescription,
    documentationTitle,
    documentationDescription,
    documentationAction,
  ] = useStrings(
    "developmentResourcesTitle",
    "developmentResourcesDescription",
    "developmentResourcesGdkTitle",
    "developmentResourcesGdkDescription",
    "developmentResourcesFirstTitle",
    "developmentResourcesFirstTitleDescription",
    "developmentResourcesDocumentationTitle",
    "developmentResourcesDocumentationDescription",
    "developmentResourcesDocumentationAction"
  );

  return (
    <section className={styles.resources}>
      <h2>{title}</h2>
      <p>{description}</p>
      <div className={styles.resourceGrid}>
        <div className={styles.resourceCard}>
          <h3>{gdkResourcesTitle}</h3>
          <p>{gdkResourcesDescription}</p>
          <a
            aria-label={gdkResourcesTitle}
            className={styles.resourceIconLink}
            href={GdkAccessResourcesUrl}
            target="_blank"
            rel="noreferrer"
          >
            <Icon aria-hidden="true" icon={Launch} iconSize={IconSize.XSmall} />
          </a>
        </div>
        <div className={styles.resourceCard}>
          <h3>{firstTitle}</h3>
          <p>{firstTitleDescription}</p>
          <a
            aria-label={firstTitle}
            className={styles.resourceIconLink}
            href={CreateTitleAndConfigureGameUrl}
            target="_blank"
            rel="noreferrer"
          >
            <Icon aria-hidden="true" icon={Launch} iconSize={IconSize.XSmall} />
          </a>
        </div>
        <div className={`${styles.resourceCard} ${styles.resourceCardFeatured}`}>
          <h3>{documentationTitle}</h3>
          <p>{documentationDescription}</p>
          <BasicButton
            as={"a"}
            buttonType={ButtonType.Secondary}
            className={styles.resourceAction}
            href={DevelopmentDocumentationUrl}
            target="_blank"
            rel="noreferrer"
          >
            {documentationAction}
            <Icon aria-hidden="true" icon={Launch} iconSize={IconSize.XSmall} />
          </BasicButton>
        </div>
      </div>
    </section>
  );
};
